<template>
  <el-cascader
    v-model="innerModelValue"
    :placeholder="'请选择'"
    :disabled="disabled"
    separator="-"
    :props="props"
    :options="areaOptions || []"
    collapse-tags
    @change="handleChange"
    v-bind="$attrs"
  ></el-cascader>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { ref, computed, onMounted, useCurrentAppInstance } from '@zto/zpage'
import { getAreasRef, loadAreas } from '../../utils/areaMerged'

const newProps = withDefaults(
  defineProps<{
    modelValue: any
    props: Record<string, any>
    disabled: boolean
  }>(),
  {
    modelValue: null,
    disabled: false
  }
)
const emit = defineEmits(['update:modelValue'])

const innerModelValue = ref<any>([])

const app = useCurrentAppInstance()

const areaOptions = computed(() => getAreasRef().value)

onMounted(async () => {
  await loadAreas(app)

  // 回显赋值
  innerModelValue.value = newProps.modelValue
})

// 修改时触发
function handleChange(vals: any) {
  let valsData = vals || [],
    resultList: any = []
  valsData.forEach((it: any, idx: number) => {
    if (newProps.props?.multiple) {
      it.forEach((el: any, idx0: number) => {
        if (idx0 == it.length - 1) {
          resultList.push(el)
        }
      })
    } else {
      if (idx == valsData.length - 1) {
        resultList.push(it)
      }
    }
  })

  // 更新父组件的值
  emit('update:modelValue', resultList)
}
</script>
